import { render } from "./PKIndexView.vue?vue&type=template&id=7b3effe4&scoped=true"
import script from "./PKIndexView.vue?vue&type=script&lang=js"
export * from "./PKIndexView.vue?vue&type=script&lang=js"

import "./PKIndexView.vue?vue&type=style&index=0&id=7b3effe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3effe4"]])

export default __exports__